<template>
  <v-row>
    <v-col cols="12" lg="6">
      <v-stepper v-model="e6" vertical class="elevation-0">
        <v-stepper-step :editable="validateStep1" :complete="e6 > 1" step="1">
          เหตุผลที่ขอทำหนังสือรับรอง
        </v-stepper-step>

        <v-stepper-content step="1">
          <div class="my-5">
            <v-select
              v-model="reason"
              :items="selectTypeList"
              item-text="reqFormReasonTypeNameTha"
              item-value="trReqFormReasonTypeId"
              label="เหตุผล"
              outlined
              hide-details
              dense
            ></v-select>
            <!-- <v-radio-group v-model="reason" class="mt-0" row hide-details dense>
              <v-radio label="ติดต่อสถาบันการเงิน" :value="1"></v-radio>
              <v-radio label="ขอวีซ่าเดินทาง" :value="2"></v-radio>
              <v-radio label="อื่นๆ" :value="3"></v-radio>
            </v-radio-group> -->
          </div>

          <div v-if="reason === 2">
            <app-country-list
              title="ประเทศที่เดินทางไป"
              @input="(value) => (country = value)"
              :value="country"
            ></app-country-list>
            <!-- <v-autocomplete
              v-model="country"
              :items="countryLists"
              label="ประเทศที่เดินทางไป"
              outlined
              dense
              hide-details
            ></v-autocomplete> -->
            <v-row>
              <v-col sm="6" cols="12">
                <v-menu
                  v-model="startDateDialog"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  :close-on-content-click="false"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="$dateFormatByLang(date.StartDate)"
                      label="ตั้งแต่วันที่"
                      append-icon="mdi-calendar"
                      readonly
                      outlined
                      hide-details="auto"
                      dense
                      v-on="on"
                      @click:append="startDateDialog = true"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :locale="$lang === 'Tha' ? 'th' : 'en'"
                    v-model="date.StartDate"
                    @input="startDateDialog = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col
                sm="6"
                cols="12"
                :class="$vuetify.breakpoint.smAndUp ? '' : 'pt-0'"
              >
                <v-menu
                  v-model="endDateDialog"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  :close-on-content-click="false"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="$dateFormatByLang(date.EndDate)"
                      label="ถึงวันที่"
                      append-icon="mdi-calendar"
                      readonly
                      outlined
                      hide-details="auto"
                      dense
                      v-on="on"
                      @click:append="endDateDialog = true"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :locale="$lang === 'Tha' ? 'th' : 'en'"
                    v-model="date.EndDate"
                    @input="endDateDialog = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <p
              v-if="
                this.$dateDiff(this.date.EndDate, this.date.StartDate) + 1 <= 0
              "
              class="error--text"
            >
              * กรุณาเลือกวันที่ให้ถูกต้อง
            </p>
            <p class="grey--text">
              * จำนวน {{ this.$dateDiff(date.EndDate, date.StartDate) + 1 }} วัน
            </p>
          </div>

          <div>
            <v-textarea
              v-model="additionReason"
              outlined
              name="input-7-4"
              label="เหตุผลเพิ่มเติม"
              dense
              hide-details
            ></v-textarea>
          </div>

          <div v-if="reason === 2">
            <v-card
              class="pa-3 mt-4"
              outlined
              style="border-color: grey !important"
            >
              <span style="font-size: 16px">แนบเอกสารเพิ่มเติม</span>
              <div class="grey--text ">
                *แนบไฟล์เฉพาะไฟล์นามสกุล .jpg, .jpeg, .png, .pdf เท่านั้น
              </div>
              <div class="grey--text pb-2">
                *กรณีไปราชการ ให้แนบหนังสือเชิญ หรือหนังสืออื่นที่เกี่ยวข้อง
              </div>
              <v-card
                class="py-1 mt-1 my-2 mx-3 text-center"
                outlined
                @click="$refs.attachedDocument.click()"
              >
                <v-icon>mdi-plus</v-icon>
                <span>เพิ่ม</span>
              </v-card>
              <input
                type="file"
                ref="attachedDocument"
                accept=".jpg, .jpeg, .png, .pdf"
                hidden
                @change="onAddAttached"
              />
              <div v-if="reasonFiles.length > 0" class="px-4 pb-2">
                <div v-for="(file, index) in reasonFiles" :key="index">
                  <v-card class="mb-2" outlined>
                    <div class="pa-2">
                      {{ file.name }}
                    </div>
                    <div class="text-right">
                      <v-btn
                        class="mb-2 mr-2"
                        color="error"
                        x-small
                        depressed
                        @click="onReasonFileRemove(index)"
                      >
                        <v-icon small>mdi-delete</v-icon> ลบ
                      </v-btn>
                    </div>
                  </v-card>
                </div>
              </div>
              <div v-if="reasonFiles.length <= 0">
                <div class="pa-2 text-center grey--text">
                  {{ $t("noData") }}
                </div>
              </div>
            </v-card>
          </div>

          <div v-if="!validateStep1" class="py-2">
            <span class="error--text">*กรอกข้อมูลให้ครบถ้วน</span>
          </div>

          <div class="text-end mt-4">
            <v-btn color="primary" :disabled="!validateStep1" @click="e6 = 2">
              ถัดไป</v-btn
            >
          </div>
        </v-stepper-content>

        <v-stepper-step :editable="validateStep2" :complete="e6 > 2" step="2">
          ภาษา
        </v-stepper-step>

        <v-stepper-content step="2">
          <v-row>
            <v-col class="py-1">
              <v-checkbox
                v-model="checkboxThai"
                label="ภาษาไทย"
                class="mt-0"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col class="py-1" sm="8" cols="12">
              <v-text-field
                v-model.number="numberThai"
                label="จำนวน (ฉบับ)"
                outlined
                dense
                type="number"
                hide-details
                :disabled="!checkboxThai"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="py-1">
              <v-checkbox
                v-model="checkboxEng"
                label="ภาษาอังกฤษ"
                class="mt-0"
                hide-details
                :disabled="reason === 4 || reason === 5"
              ></v-checkbox>
            </v-col>
            <v-col class="py-1" sm="8" cols="12">
              <v-text-field
                v-model.number="numberEng"
                label="จำนวน (ฉบับ)"
                outlined
                dense
                type="number"
                hide-details
                :disabled="!checkboxEng"
              ></v-text-field>
            </v-col>
          </v-row>

          <div v-if="!validateStep2" class="py-2">
            <span class="error--text"
              >*กรุณาเลือกอย่างน้อย 1 ภาษา และใส่จำนวนที่ต้องการให้ถูกต้อง</span
            >
          </div>

          <div class="py-2">
            <span>ระยะเวลาในการทำหนังสือรับรอง : 2-3 วัน</span>
          </div>

          <div class="pb-y grey--text">
            <span
              >*ในกรณีเร่งด่วนโปรดติดต่อ กองบริหารงานบุคคล สำนักงานมหาวิทยาลัย
              มหาวิทยาลัยเชียงใหม่ โทรศัพท์ (053)943120</span
            >
          </div>

          <div class="text-end mt-4">
            <v-btn color="primary" :disabled="!validateStep2" @click="e6 = 3">
              ถัดไป</v-btn
            >
          </div>
        </v-stepper-content>

        <v-stepper-step :editable="validateStep3" :complete="e6 > 3" step="3">
          เบอร์โทรศัพท์ติดต่อ
        </v-stepper-step>

        <v-stepper-content step="3">
          <div class="py-1">
            <v-text-field
              v-model="phoneNumber"
              label="เบอร์โทรศัพท์ติดต่อ"
              outlined
              dense
              hide-details
              :maxlength="10"
            ></v-text-field>
            <div class="py-2 grey--text">
              <span
                >*ตรวจสอบเบอร์โทรศัพท์ของท่านให้ถูกต้องเนื่องจากต้องใช้ในการติดต่อเพื่อมารับใบรับรอง</span
              >
            </div>
            <div v-if="!validateStep3">
              <span class="error--text">*กรุณาใส่เบอร์โทรศัพท์</span>
            </div>
          </div>

          <div class="text-end mt-4">
            <v-btn color="primary" :disabled="!validateStep3" @click="e6 = 4">
              ถัดไป</v-btn
            >
          </div>
        </v-stepper-content>

        <v-stepper-step step="4">
          ยืนยันข้อมูล
        </v-stepper-step>
        <v-stepper-content step="4">
          <template v-for="(item, index) in confirmData">
            <v-row v-if="item.value" :key="'confirmData-' + index">
              <v-col class="py-1">
                <span>
                  {{ item.text }}
                </span>
              </v-col>
              <v-col class="py-1 grey--text" sm="8" cols="12">
                <span :class="$vuetify.breakpoint.smAndUp ? '' : 'pl-2'">
                  {{ item.value }}
                </span>
              </v-col>
            </v-row>
          </template>
          <div class="text-end">
            <v-btn @click="onSubmit" :disabled="!oldValidate" color="primary">
              ยืนยัน</v-btn
            >
          </div>
        </v-stepper-content>
      </v-stepper>
    </v-col>
  </v-row>
</template>

<script>
import countryList from "@/assets/json/countryList.json";
import AppCountryList from "@/components/base/AppCountryList.vue";
export default {
  props: {
    type: {
      type: String,
      default: "Current",
    },
    oldEmpData: {
      type: Object,
      default: () => {},
    },
    oldValidate: {
      type: Boolean,
      default: true,
    },
  },
  components: [AppCountryList],
  data() {
    return {
      e6: 1,
      reason: 1,
      speed: 1,
      date: {
        StartDate: new Date().toISOString().substr(0, 10),
        EndDate: new Date().toISOString().substr(0, 10),
      },
      startDateDialog: false,
      endDateDialog: false,
      reasonFiles: [],
      checkboxThai: false,
      checkboxEng: false,
      country: {},
      additionReason: "",
      numberThai: "",
      numberEng: "",
      phoneNumber: "",
      selectTypeList: [],
    };
  },
  async mounted() {
    this.selectTypeList = await this.apiGetReasonType();
  },
  watch: {
    reason() {
      if (this.reason === 4 || this.reason === 5) {
        this.checkboxEng = false;
        this.numberEng = "";
      }
    },
  },
  computed: {
    countryLists() {
      let data = [];
      countryList.forEach((item) => {
        data.push(item.country);
      });
      return data;
    },

    confirmData() {
      return [
        {
          text: "เหตุผล :",
          value: this.reasonInfo(this.reason),
        },
        {
          text: "เหตุผลเพิ่มเติม :",
          value: this.additionReason,
        },
        {
          text: "ภาษาไทย :",
          value: this.checkboxThai ? this.numberThai : 0,
        },
        {
          text: "ภาษาอังกฤษ :",
          value: this.checkboxEng ? this.numberEng : 0,
        },
        {
          text: "เบอร์โทรศัพท์ติดต่อ :",
          value: this.phoneNumber,
        },
      ];
    },

    validateStep1() {
      let result = false;
      if (this.reason === 2) {
        result =
          this.additionReason &&
          this.country.countryID &&
          this.$dateDiff(this.date.EndDate, this.date.StartDate) + 1 > 0;
      } else {
        result = !!this.additionReason;
      }
      return result;
    },
    validateStep2() {
      let result = false;

      if (this.checkboxThai && this.checkboxEng) {
        result =
          this.checkboxThai &&
          this.numberThai &&
          this.numberThai > 0 &&
          this.isDigit(this.numberThai) &&
          this.checkboxEng &&
          this.numberEng &&
          this.numberEng > 0 &&
          this.isDigit(this.numberEng);
      } else if (this.checkboxEng) {
        result =
          this.checkboxEng &&
          this.numberEng &&
          this.numberEng > 0 &&
          this.isDigit(this.numberEng);
      } else if (this.checkboxThai) {
        result =
          this.checkboxThai &&
          this.numberThai &&
          this.numberThai > 0 &&
          this.isDigit(this.numberThai);
      }

      return result;
    },
    validateStep3() {
      return (
        !!this.phoneNumber &&
        this.isDigit(this.phoneNumber) &&
        this.phoneNumber.length === 10
      );
    },
  },
  methods: {
    isDigit(n) {
      return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
    },
    reasonInfo(reason) {
      switch (reason) {
        case 1:
          return "ติดด่อสถาบันการเงิน";
        case 2:
          return "ขอวีซ่าเดินทาง";
        case 3:
          return "อื่นๆ";
        case 4:
          return "ติดต่อธนาคาร ธอส.";
        case 5:
          return "ติดต่อธนาคาร กรุงไทย";
      }
    },
    onAddAttached(e) {
      const filename = e.target.files[0].name.split(".");
      const fileExt = filename[filename.length - 1].toLowerCase();
      const accepted = ["jpg", "jpeg", "png", "pdf"];

      if (accepted.includes(fileExt)) {
        this.reasonFiles.push(e.target.files[0]);
      } else {
        alert(this.$t("alertErrorMessage.noAcceptFileType"));
      }
      // console.log(this.country)
    },
    onReasonFileRemove(index) {
      this.reasonFiles.splice(index, 1);
    },
    validateForm() {
      return this.validateStep1 && this.validateStep2 && this.validateStep3;
    },
    async onSubmit() {
      if (this.validateForm()) {
        try {
          let dataCert = {};
          dataCert.ReqFormReasonTypeId = this.reason || "";
          dataCert.ReasonText = this.additionReason || "";
          dataCert.FormReasonVisa =
            this.reason === 2
              ? {
                  CountryTha: this.country.countryNameTha,
                  CountryEng: this.country.countryNameEng,
                  StartDate: this.date.StartDate,
                  EndDate: this.date.EndDate,
                  AmountDay:
                    this.$dateDiff(this.date.EndDate, this.date.StartDate) + 1,
                }
              : "";
          dataCert.isTh = this.checkboxThai;
          dataCert.isEn = this.checkboxEng;
          dataCert.CopyTh = this.numberThai || 0;
          dataCert.CopyEn = this.numberEng || 0;
          dataCert.ReqTimeTypeId = this.speed || "";
          dataCert.MobilePhone = this.phoneNumber || "";
          dataCert.isConsent = true;

          let formData = new FormData();
          formData.append("dataCert", JSON.stringify(dataCert));

          if (this.reason === 2) {
            for (let index in this.reasonFiles) {
              let running_number = parseInt(index) + 1;
              formData.append(
                "filename" + running_number,
                this.reasonFiles[index]
              );
            }
          }
          // for (let pair of formData.entries()) {
          //   console.log(pair[0] + ', ' + pair[1])
          // }
          if (this.type === "Old") {
            let dataCertOldEmpInfo = this.oldEmpData;

            formData.append(
              "dataCertOldEmpInfo",
              JSON.stringify(dataCertOldEmpInfo)
            );
            await this.$store.dispatch("reqCer/addNewRequestOldEmp", formData);
            this.$router.push("/ReqCer/admin");
            // console.log(res)
            // for (var pair of formData.entries()) {
            //   console.log(pair[0] + ', ' + pair[1])
            // }
          } else {
            await this.$store.dispatch("reqCer/addNewRequest", formData);
            this.$router.push("/ReqCer");
            // console.log(res)
          }
        } catch (e) {
          console.log(e.response || e);
        }
      } else {
        if (!this.validateStep1) {
          this.currentStep = 1;
        } else if (!this.validateStep2) {
          this.currentStep = 2;
        } else if (!this.validateStep3) {
          this.currentStep = 3;
        }
      }
    },
    async apiGetReasonType() {
      try {
        const res = await this.$store.dispatch("reqCer/getBasicInfo");
        return res.data.data.trReqFormReasonTypeList;
      } catch (e) {
        console.log(e.response || e);
      }
    },
  },
};
</script>
